import axios from 'axios';

export const env = {
	DOMAIN: process.env.REACT_APP_DOMAIN || 'http://localhost:8000',
};

const API = axios.create({ baseURL: `${env.DOMAIN}/api/` });

// Fetch all articles.
export const fetchArticles = () => API.get('articles/');

// Fetch a single article by slug.
export const fetchArticle = slug => API.get(`articles/${slug}/`);

export const fetchProjects = () => API.get('projects/');

export const fetchResume = () => API.get('resume/');

export const fetchGithub = async (username) => {
  const response = await fetch(`https://api.github.com/users/${username}/events`);
  if (!response.ok) {
    throw new Error('Failed to fetch GitHub events');
  }
  return await response.json();
};
